<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
	defineProps<{
		title: string;
		subtitle?: string;
		icon?: string;
		tone?: 'emerald' | 'sky';
	}>(),
	{ subtitle: '', icon: '', tone: 'emerald' }
);

const toneClass = computed(() =>
	props.tone === 'sky'
		? 'tw3-bg-sky-100 tw3-text-sky-700'
		: 'tw3-bg-primary-50 tw3-text-primary-600'
);
</script>

<template>
	<div class="tw3-mb-5 tw3-flex tw3-items-start tw3-gap-3">
		<div
			v-if="icon"
			class="tw3-flex tw3-size-10 tw3-shrink-0 tw3-items-center tw3-justify-center tw3-rounded-xl"
			:class="toneClass"
		>
			<i :class="icon" />
		</div>
		<div>
			<h2 class="tw3-text-lg tw3-font-semibold">{{ title }}</h2>
			<p v-if="subtitle" class="tw3-mt-0.5 tw3-text-sm tw3-text-surface-500">
				{{ subtitle }}
			</p>
		</div>
	</div>
</template>
